import { useEffect, useState } from "react";
import { Paperclip } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";

export function ProofAttachments({ proposalId, onChange, reloadKey }) {
  const [a, setA] = useState(null);
  useEffect(() => { api.get(`/proposals/${proposalId}/attachments`).then((r) => setA(r.data)).catch(() => {}); }, [proposalId, reloadKey]);
  const save = async (body) => {
    try { const { data } = await api.put(`/proposals/${proposalId}/attachments`, body); setA(data); onChange?.(); }
    catch (e) { toast.error(formatErr(e)); }
  };
  const toggle = (d) => save({ doc_ids: a.docs.filter((x) => (x.doc_id === d.doc_id ? !x.selected : x.selected)).map((x) => x.doc_id) });
  if (!a) return null;
  const n = a.docs.filter((d) => d.selected).length;
  return (
    <div className="bg-white border border-slate-200 rounded-lg p-6" data-testid="proof-attachments-panel">
      <div className="flex items-center gap-2"><Paperclip className="h-5 w-5 text-emerald-600" /><h3 className="font-display text-lg font-bold text-slate-900">Proof attachments</h3>
        <span className="ml-auto text-xs font-semibold text-slate-600" data-testid="proof-attachments-count">{n} in PDF</span></div>
      <p className="text-xs text-slate-500 mt-1">Added after your proposal in the PDF as Attachment A, B, C… The Word file lists them.</p>
      {!a.docs.length ? <p className="text-sm text-slate-400 mt-3">Upload PDFs or photos to the Document Vault to attach them.</p> : (
        <div className="mt-3 space-y-1 max-h-[300px] overflow-y-auto pr-1">
          {a.docs.map((d) => (
            <label key={d.doc_id} className="flex items-start gap-2 py-1.5 cursor-pointer" data-testid={`proof-attachment-${d.doc_id}`}>
              <Checkbox checked={d.selected} onCheckedChange={() => toggle(d)} className="mt-0.5" data-testid={`proof-attachment-toggle-${d.doc_id}`} />
              <span className="min-w-0"><span className="block text-sm text-slate-800 truncate">{d.label}</span>
                <span className="block text-[11px] text-slate-500 truncate">{d.filename}{d.suggested ? " · suggested" : ""}</span></span>
            </label>))}
        </div>)}
      {a.custom && <button onClick={() => save({ doc_ids: [], reset: true })} className="text-xs text-emerald-700 font-medium mt-3 hover:underline" data-testid="proof-attachments-reset">Go back to suggested picks</button>}
    </div>
  );
}
